import { render } from "./AllExtraServices.vue?vue&type=template&id=2617f867&scoped=true"
import script from "./AllExtraServices.vue?vue&type=script&lang=js"
export * from "./AllExtraServices.vue?vue&type=script&lang=js"

import "./AllExtraServices.vue?vue&type=style&index=0&id=2617f867&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2617f867"]])

export default __exports__